import { debounceTime } from 'rxjs/operators';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { Injectable } from '@angular/core';
import { IonNav } from '@ionic/angular';
import { LazyComponent, NothingSelectedView } from '../lazy-components';
import { getComponent } from './component-registry';


export enum ChildNavNames {
  AccountManagementNavigation = 'accountmanagementrightpane',
  ActivitiesPageNavigation = 'activitiespagerightpane',
  ContactPageNavigation = 'contactpagerightpane',
  AccountPageNavigation = 'accountpagerightpane',
  ScientificActivityNavigation = 'scientificactivityrightpane',
  PresentationToolsNavigation = 'presentationtoolsrightpane',
  OrderManagementNavigation = 'ordermanagementrightpane',
  AppsettingNavigation = 'appsettingspagerightpane',
  OpportunityManagementNavigation = 'opportunitymanagementrightpane',
  MeetingPresentationNavigation = 'meetingpresentationpane',
  MainToolTemplateNavigation = 'maintooltemplaterightpane',
  MarketScanNavigation = 'marketscanrightpane',
  EventsToolNavigation = 'eventtoolsrightpane',
  ResourceToolNavigation = 'resourcerightpane',
  TemplatePreviewNavigation = 'templatepersonalizepagerightpane',
  EmailTemplateNavigation = "emailtemplaterightpane",
  CallPlanPageNavigation = 'callPlanPageRightPane',
  CalendarInviteTemplateNavigation = 'calendarinvitetemplatenavigation',
  CoachingActivitiesNavigation = 'coachingactivitiesrightpane',
  CoachingDetailsNavigation = 'coachingdetailsrightpane',
  CustomerAllocationsToolNavigation = 'customerallocationtoolrightpane',
  OpportunitySelectionNavigation = 'opportunityselectionrightpane',
  EventSelectionNavigation = 'eventselectionrightpane',
  FieldMaterialManagementNavigation = 'fieldmaterialrightpane',
  AccountPlanActivitiesNavigation = "accountplanactivitiesrightpane",
  MarketingPlanNavigation="marketingplanrightpane",
  QuotesNavigation="quotesrightpane",
  PharmacovigilanceNavigation = 'pharmacovigilancerightpane',
  TerritoryNavigation="territoryrightpane",
  KOLStatusPageNavigation = 'kolstatuspagerightpane',
  SurveyNavigation = 'surveyRightpane',
  MedicalInsightPageNavigation = 'medicalinsightpagenavigation',
  MedicalInquiryNavigation = 'medicalinquiryrightpane',
  ExternalApp='externalapp',
  SurgeryContractNavigation = 'procedurecontractpane',
  NotificationPageNavigation = 'notificationpagerightpane',
  SchedulerPageNavigation = 'schedulerpagerightpane',
  VoiceNotesNavigation = 'voicenotesrightpane',
  CaseManagementNavigation = 'casemanagementrightpane',
  TimeOffNavigation = 'timeoffrightpane',
}








export enum PageName {
  GoAppActivitiesPageComponent = 1,
  ActivitiesDetailsPaneComponent = 2,
  ScientificActivityPage = 3,
  ScientificActivityList = 4,
  ScientificActivityDetail = 5,
  ScientificPlanFollowUpTask = 6,
  AppSettingsDetailsComponent = 7,
  NewActivityComponent = 8,
  AppSettingsPageComponent = 9,
  AccountPageComponent = 10,
  AccountDetailsComponent = 11,
  AccountListRoComponent = 12,
  CallPlanComponent = 14,
  CallPlanDetails = 15,
  CallPlanCustDetailsComponent = 16,
  CoachingComponent = 17,
  CoachingDetailsComponent = 18,
  CoachingForSelectComponent = 19,
  CoachingActivitiesComponent = 20,
  ContactPageComponent = 21,
  ContactDetailsComponent = 22,
  ContactListROComponent = 23,
  ContactNewAddressComponent = 24,
  ContactAcountAffiliationComponent = 25,
  PresentationPageComponent = 26,
  PresentationPreviewComponent = 27,
  PresentationMeetingComponent = 28,
  PresentationFullscreenComponent = 29,
  MyAssistantComponent = 30,
  RemoteURLEmailTemplate = 31,
  LocationComponent = 32,
  SettingsComponent = 33,
  TimeOffComponent = 34,
  TimeOffDetailsComponent = 35,
  ResourceDetailsComponent = 36,
  ResourcePageComponent = 37,
  NewTimeOffComponent = 38,
  ToolsDrawer = 39,
  SchedulerDetailComponent = 40,
  NewSampleActivityComponent = 41,
  AllocationComponent = 42,
  AllocationOrdersList = 43,
  ContactAllocationEligibilitiesComponent = 44,
  IOMultiSelect = 45,
  CaptureAllocationOrderComponent = 46,
  SchedulerPopoverComponent = 47,
  ChildUsersPageComponent = 50,
  ConsentDetailsComponent = 51,
  EmailTemplatePageComponent = 52,
  EmailDetailsPageComponent = 53,
  AccountManagementPageComponent = 54,
  AccountPlanListComponent = 55,
  AccountPlanDetailsComponent = 56,
  AccountObjectiveDetailsComponent = 57,
  PlanProgressReportComponent = 58,
  FollowUpActionDetailComponent = 59,
  NothingSelectedView = 60,
  TemplatePersonalizePageComponent = 61,
  ResourceInteractionDetailComponent = 62,
  CaseManagementHomePage = 63,
  CaseManagementDetailComponent = 64,
  InMeetingCasesComponent = 65,
  OrderManagementPageComponent = 66,
  OrdersListComponent = 67,
  OrderDetailsComponent = 68,
  SelectListComponent = 70,
  CustomerInsightComponent = 72,
  CustomerJourneyComponent = 73,
  CustomerRelationshipComponent = 74,
  CustomerInterestComponent = 75,
  RelationshipListComponent = 76,
  LanguageSettingsComponent = 77,
  GeneralSettingsComponent = 78,
  AboutSettingsComponent = 79,
  DateFormatsPage = 80,
  LanguageListComponent = 81,
  OpportunityManagementPage = 82,
  OpportunitiesListComponent = 83,
  OpportunityDetailsComponent = 84,
  OpportunityInfoComponent = 85,
  OpportunityQuotesComponent = 86,
  OpportunityAgreementsComponent = 87,
  OpportunityOrdersComponent = 88,
  OpportunityQuoteDetailsComponent = 89,
  NewOpportunityComponent = 90,
  IndRightpaneReadonlyComponent = 91,
  MarketingEmailDetailsComponent = 92,
  AccountPlanOpportunityListComponent = 93,
  AboutDetailsComponent = 94,
  MainToolTemplateComponent = 95,
  AccountFormComponent = 96,
  InisghtsPlusComponent = 97,
  GeneralInsightsPlusComponent = 98,
  DynamicFormComponent = 99,
  CaptureCustomerInquireComponent = 100,
  GeneeInfoComponent = 101,
  PhoneCallDetailsComponent = 102,
  ContactConsentCaptureComponent = 103,
  PlansPredictionsComponent = 104,
  JourneyInsightsComponent = 105,
  InterestInsightsComponent = 106,
  RelationshipInsightsComponent = 107,
  MorePlansInsightsComponent = 108,
  GeneeNotificationComponent = 109,
  MarketScanPageComponent = 110,
  MarketScanDetailsComponent = 111,
  EventsToolPageComponent = 112,
  EventsListComponent = 113,
  EventDetailsPageComponent = 114,
  CaptureEventsComponent = 115,
  PdfPreviewComponent = 116,
  ParticipantListComponent = 117,
  TemplatePreviewComponent = 118,
  ReplacementTokenListComponent = 119,
  EmailTemplateDetailsComponent = 120,
  NewChangeRequestComponent = 121,
  CrDetailsComponent = 122,
  AccountCrDetailsComponent = 123,
  EdgeAnalyticsListComponent = 124,
  EdgeAnalyticsDetailComponent = 125,
  PlansListComponent = 126,
  ImpactDetailsComponent = 127,
  SurgeryOrderDetailsComponent = 129,
  CalendarInviteComponent = 130,
  CalendarInviteTemplatePageComponent = 131,
  CalendarInviteTemplateListComponent = 132,
  ContactTimelineComponent = 133,
  AccountTimelineComponent = 134,
  ScientificActivityTimeline = 135,
  OpportunityCollaboratorsComponent = 136,
  ActivitySkeletonPaneComponent = 137,
  AllocationShipmentDetailsComponent = 138,
  AffiliationExplorerComponent = 139,
  NotificationListComponent = 140,
  SurveyComponent = 141,
  NotificationDetailsComponent = 143,
  CustomerAssessComponent = 144,
  SectionSpecificComponent = 145,
  AppSettingsRecommendationsComponent = 146,
  OpportunitySelectionPage = 147,
  NewAccountPlanComponent = 148,
  ProcedureTrackerDetailsComponent = 149,
  ProcedureTrackerComponent = 150,
  ExpensesDetails = 151,
  FieldMaterialManagementPageComponent = 152,
  EventNotesComponent = 153,
  AssetDetailsComponent = 154,
  AssetTransferDetailsComponent = 155,
  AccountPlanActivities = 156,
  MarketScanEditPageComponent = 157,
  PresentationDetailComponent = 158,
  EventParticipantComponent = 159,
  MarketingPlanManagementPageComponent = 160,
  MarketingPlanDetails = 161,
  CustomerAvailabilityComponent = 162,
  UserInventoryListComponent = 163,
  UserInventoryDetailComponent = 164,
  QuotePageComponent = 165,
  QuoteDetailsComponent = 166,
  CustomerCallPlanPage = 167,
  CustomerCallPlanDetails = 168,
  NewQuoteComponent = 169,
  QuoteProductsComponent = 170,
  CustomerCallPlanSuggest = 171,
  IndFilterMenuComponent = 172,
  PharmacovigilancePage = 173,
  PharmacovigilanceList = 174,
  PharmacovigilanceDetail = 175,
  CustomNotificationDetails = 176,
  CustomerAssessTeamviewComponent = 177,
  KOLStatusPageComponent = 178,
  KOLDetailsComponent = 179,
  KOLStatusListComponent = 180,
  ContactMedicalInsightComponent = 181,
  TerritoryManagementPageComponent = 182,
  TerritoryManagementDetailsComponent = 183,
  SurveyPageComponent = 184,
  SurveyListComponent = 185,
  SurveyDetailsComponent = 186,
  SurveyPreviewComponent = 187,
  SurveyListCardviewComponent = 188,
  MedicalInsightPageComponent = 189,
  EventAttendiesListComponent = 190,
  Contact360DetailsComponent = 191,
  PersonalizedQuickGlanceViewComponent = 192,
  StoreCheckDetailsComponent = 193,
  IndPhotoCaptureViewerComponent = 194,
  IndPhotoViewerComponent = 195,
  ContactSentimentHistoryListComponent = 196,
  MeetingSentimentHistoryDetailComponent = 197,
  AppealDetailsComponent = 198,
  SurgeryOrderContractComponent = 199,
  SurgeryOrderContractListComponent = 200,
  SurveyHistoryComponent = 201,
  SetBookingActivityDetailsComponent = 202,
  ShortCallHomeComponent = 205,
  DisplayFormComponent = 206,
  MainToolTemplateDetailsComponent = 207,
  ContactOmnichannelOpportunitiesComponent = 208,
  GoAppHomeComponent = 209,
  GoAppNotificationPageComponent = 210,
  GoAppSettingsComponent = 211,
  GoAppActivitiesComponent = 212,
  IndFilterMenuModalComponent = 213,
  ExternalAppFrameComponent = 214,
  SchedulerPageComponent = 215,
  CaptureSignatureMeetingComponent = 216,
  ConsentTermDetailsComponent = 217,
  ReconciliationListComponent = 218,
  ReconciliationDetailComponent = 219,
  TrendingAccountsComponent = 220,
  ResourceShareHistoryComponent = 221,
  NewManageListComponent = 222,
  SettingsOptionListComponent = 223,
  MedicalInquiryHomePage = 224,
  MedicalInquiryNewComponent = 225,
  OrderAddQuantityComponent = 226,
  ContactTimelinePageComponent = 227,
  AccountTimelinePageComponent = 228,
  ContactOmnichannelEventsComponent = 229,
  SurgeryOrderContractDetailsComponent = 230,
  MedicalInquiryDetailComponent = 231,
  MedProSearchPageComponent = 232,
  NewSampleDeliveryRequestComponent = 233,
  SampleDeliveryRequestDetailComponent = 234,
  VoiceNotesPageComponent = 235,
  VoiceNoteDetailsComponent = 236,
  SuperTargetListComponent = 237,
  ContactCallPlanListComponent = 238,
  OrderManagementToolPage = 239,
}
export interface PageStack {
    pageName: PageName,
    masterPageName: PageName
}

@Injectable({
  providedIn: 'root'
})
export class NavigationService {
    private _pageStack: Array<PageStack> = [];
    private _activeChildNavName:ChildNavNames;
    private _defaultNav: IonNav;
    private _rightPaneNavCtrlStack: Array<{
        navCtrl:IonNav,
        navName:ChildNavNames,
        isRightPaneViewActive: boolean,
        navPageStack:Array<PageStack>,
    }> =  [];
    public isModalViewOpen: boolean = false;
    private _currentPageStack$: BehaviorSubject<PageStack[]> = new BehaviorSubject(this._pageStack);
    readonly currentPageStack$: Observable<PageStack[]> = this._currentPageStack$.asObservable().pipe(debounceTime(0));

    public childNavPopObserver = new Subject<PageName>();

    constructor() {
    }

    private async resolveComponent(component: any) {
      if (component instanceof LazyComponent) {
        component = component.resolve();
      }
      return Promise.resolve(component);
    }

    initStack(homeNavCtrl: IonNav) {
        this._pageStack = [{ pageName: PageName.GoAppActivitiesPageComponent, masterPageName: PageName.GoAppActivitiesPageComponent }];
        this._defaultNav = homeNavCtrl;//this.appCtrl.getActiveNavs()[0];
        this._currentPageStack$.next(this._pageStack);
    }

    /**
     * Push a page with the name of page which will be tracked by '_pageStack' property
     * so that we can keep track the pushed page stack.
     * We assume that we are using this service within the scope of the home.ts and since
     * we use ion-nav that takes 'GoAppActivitiesPageComponent' as root, we will use that navCtrl
     * for navigation rather than the root navCtrl which has 'HomePage' as root.
     * getActiveNavs() returns array of active navs other than the root nav and it is a recommended method to
     * get an active nav according to the ionic console warning, however there is not enough documentation regarding this as of yet.
     * Since our current acrhitecture utilizes only one ion-nav, we assume that the getAcitveNavs() will return an array with only one nav.
     * Leaving 'navCtrl' as optional argument just in case we need to use other navCtrl.
     * @param pageComponentToPush
     * @param newPageName
     * @param params
     * @param options
     * @param navCtrl
     */
    async pushWithPageTracking(pageComponentToPush: any, newPageName: PageName, params?: any, masterPageName?: PageName, options: any = {animate: false}, navCtrl?: IonNav): Promise<any> {
      if (typeof pageComponentToPush === 'number') {
        const lazy = getComponent(pageComponentToPush);
        if (!lazy) {
          console.warn(`NavigationService: no component registered for PageName: ${pageComponentToPush}`);
          return;
        }
        pageComponentToPush = lazy;
      }
      pageComponentToPush = await this.resolveComponent(pageComponentToPush);
        const activeNav = navCtrl ? navCtrl : this._defaultNav;
        if (activeNav) {
            this._pushToStack({ pageName: newPageName, masterPageName: masterPageName ? masterPageName : this.getCurrentMasterPageName() });
            //console.log('%%% curPageStack after push: ', this._pageStack);
            return navCtrl ? navCtrl.push(pageComponentToPush, params, options) : this._defaultNav.push(pageComponentToPush, params, options);
        } else {
            return Promise.reject('NavigationService: pushWithPageTracking: Nav controller undefined');
        }
    }
    /**
     * Resolves a PageName to its registered component and pushes it onto the given nav stack.
     * Use this instead of navCtrl.push(ComponentClass, ...) to avoid direct component class imports.
     */
    async navCtrlPush(pageName: PageName, params?: any, options?: any, navCtrl?: IonNav): Promise<any> {
      const lazy = getComponent(pageName);
      if (!lazy) {
        console.warn(`NavigationService: navCtrlPush: No component registered for PageName: ${pageName}`);
        return;
      }
      const component = await this.resolveComponent(lazy);
      const activeNav = navCtrl ?? this._defaultNav;
      if (activeNav) {
        return activeNav.push(component, params, options);
      }
      throw new Error('NavigationService: navCtrlPush: Nav controller undefined');
    }

    async setRootWithTracking(pageComponentToPush: any, newPageName: PageName, params?: any, masterPageName?: PageName, options: any = {animate: false}, navCtrl?: IonNav): Promise<any> {
      if (typeof pageComponentToPush === 'number') {
        const lazy = getComponent(pageComponentToPush);
        if (!lazy) {
          console.warn(`NavigationService: no component registered for PageName: ${pageComponentToPush}`);
          return;
        }
        pageComponentToPush = lazy;
      }
      pageComponentToPush = await this.resolveComponent(pageComponentToPush);
        const activeNav = navCtrl ? navCtrl : this._defaultNav;
        if (activeNav) {
          // Clear the stack and set only the new page as root
          this._pageStack = [{ pageName: newPageName, masterPageName: masterPageName ? masterPageName : newPageName }];
          this._currentPageStack$.next(this._pageStack);
            //console.log('%%% curPageStack after setRoot: ', this._pageStack);
            return navCtrl ? navCtrl.setRoot(pageComponentToPush, params, options) : this._defaultNav.setRoot(pageComponentToPush, params, options);
        } else {
            return Promise.reject('NavigationService: setRootWithTracking: Nav controller undefined');
        }
    }

    popWithPageTracking(options: any = {animate: false}, navCtrl?: IonNav): Promise<any> {
        const activeNav = navCtrl ? navCtrl : this._defaultNav;
        if (activeNav) {
          if(activeNav.canGoBack() && this._pageStack.length > 1) {
            this._popFromStack();
            //console.log('%%% curPageStack after pop: ', this._pageStack);
            return activeNav.pop(options);
          }
        } else {
            return Promise.reject('NavigationService: popWithPageTracking: Nav controller undefined');
        }
    }

    popToRootWithPageTracking(options: any = {animate: false}, navCtrl?: IonNav): Promise<any> {
        const activeNav = navCtrl ? navCtrl : this._defaultNav;
        if (activeNav) {
            this.initStack(this._defaultNav);
            //console.log('%%% curPageStack after popToRoot: ', this.getCurrentPageStack());
            return navCtrl ? navCtrl.popToRoot(options) : this._defaultNav.popToRoot(options);
        } else {
            return Promise.reject('NavigationService: popToRootWithPageTracking: Nav controller undefined');
        }
    }

    private getActiveChildNav(){
        return this._rightPaneNavCtrlStack[this._rightPaneNavCtrlStack.length - 1];
    }


    public popChildNavCtrlFromStack(childNavName:ChildNavNames):Promise<any>{
        return new Promise(async (resolve,reject)=> {
            if(this._activeChildNavName){
                if(childNavName == this._activeChildNavName){
                    this._rightPaneNavCtrlStack.pop();
                    if (this._rightPaneNavCtrlStack.length > 0)
                      this._activeChildNavName = this._rightPaneNavCtrlStack[this._rightPaneNavCtrlStack.length - 1].navName;
                    resolve('');
                }else{
                    reject('Please pop the current active child nav first');
                }
            }else{
                reject('No active child nav to pop');
            }
        });
    }

    /**
     * OMNI-59745: Remove a specific child-nav controller from the right-pane stack by reference,
     * regardless of its position in the stack. Unlike popChildNavCtrlFromStack (which pops the TOP
     * entry matching the active name), this lets a page remove exactly its OWN entry on destroy even
     * when a newer instance of the same page has already pushed its entry on top — which happens on
     * tool re-entry via setRoot (new instance ngOnInit runs before old instance ngOnDestroy). Without
     * this, the outgoing instance's ngOnDestroy popped the incoming instance's freshly-registered nav,
     * leaving the dead nav active so the right pane stayed stuck on "nothing selected".
     */
    public removeChildNavCtrlFromStackByRef(navCtrl: IonNav): void {
        if (!navCtrl) return;
        const idx = this._rightPaneNavCtrlStack.findIndex(entry => entry.navCtrl === navCtrl);
        if (idx === -1) return;
        this._rightPaneNavCtrlStack.splice(idx, 1);
        if (this._rightPaneNavCtrlStack.length > 0) {
            this._activeChildNavName = this._rightPaneNavCtrlStack[this._rightPaneNavCtrlStack.length - 1].navName;
        }
    }

    public initRightPaneChildNav (nav:IonNav,childNavName:ChildNavNames,masterPageName:PageName,rightPaneNavFlag?:boolean, data?: any):void {
        this._rightPaneNavCtrlStack.push({
            navCtrl: nav,
            navName: childNavName,
            isRightPaneViewActive: rightPaneNavFlag,
            navPageStack: [],
        })
        this._activeChildNavName = childNavName;
        if (data) {
        this.setChildNavRoot(NothingSelectedView,PageName.NothingSelectedView,masterPageName,data);
        } else {
          this.setChildNavRoot(NothingSelectedView,PageName.NothingSelectedView,masterPageName);
        }
    }

    private readonly _childNavRightPaneView$ = new BehaviorSubject<boolean>(false);
    /**
     * Emits when the active child nav starts or stops hosting a page. OnPush tools that
     * gate their right pane on isActiveChildNavRightPaneViewDisplayed need this to repaint;
     * it reports the existing flag rather than holding state of its own.
     */
    public readonly childNavRightPaneView$ = this._childNavRightPaneView$.asObservable();

    public setChildNavRightPaneView(flag:boolean){
        this.getActiveChildNav().isRightPaneViewActive = flag;
        this._childNavRightPaneView$.next(flag);
    }

    public get isActiveChildNavRightPaneViewDisplayed():boolean {
        if(this.getActiveChildNav()){
            return this.getActiveChildNav().isRightPaneViewActive;
        }else{
            return false;
        }
    }

    public async setChildNavRoot (pageToSet:any, newPageName:PageName, masterPageName?:PageName, data?:any, options: any = {animate: false}) : Promise<any> {
        if (typeof pageToSet === 'number') {
          const lazy = getComponent(pageToSet);
          if (!lazy) {
            console.warn(`NavigationService: no component registered for PageName: ${pageToSet}`);
            return;
          }
          pageToSet = lazy;
        }
        pageToSet = await this.resolveComponent(pageToSet);
        if(this.getActiveChildNav()){
            if(!masterPageName){
                masterPageName = this.getActiveChildNav().navPageStack[0].masterPageName;
            }
            this.getActiveChildNav().navPageStack = [];
            this.getActiveChildNav().navPageStack.push({
                pageName: newPageName,
                masterPageName: masterPageName,
            });
            return this.getActiveChildNav().navCtrl?.setRoot(pageToSet, data,options);
        }else{
            return Promise.reject('Invalid child nav controller');
        }

    }

    public async getActiveChildComponent() {
        return (await this.getActiveChildNav()?.navCtrl?.getActive())?.component;
    }

    public async canChildNavGoBack() {
        return this.getActiveChildNav()?.navCtrl?.canGoBack();
    }

    public async pushChildNavPageWithPageTracking (pageComponentToPush: any, newPageName: PageName, masterPageName?: PageName, params?: any, options: any = {animate: false}):Promise<any>{
        if (typeof pageComponentToPush === 'number') {
          const lazy = getComponent(pageComponentToPush);
          if (!lazy) {
            console.warn(`NavigationService: no component registered for PageName: ${pageComponentToPush}`);
            return;
          }
          pageComponentToPush = lazy;
        }
        pageComponentToPush = await this.resolveComponent(pageComponentToPush);
        if(this.getActiveChildNav()){
            if(!masterPageName){
                masterPageName = this.getActiveChildNav().navPageStack[0].masterPageName;
            }
            this.getActiveChildNav().navPageStack.push({
                pageName: newPageName,
                masterPageName: masterPageName,
            });
            return this.getActiveChildNav().navCtrl.push(pageComponentToPush,params,options)
            //return this.navService.pushWithPageTracking(pageComponentToPush,newPageName,params,masterPageName,options,this._ChildNav);
        }else{
            return Promise.reject('Invalid child nav controller');
        }
    }

    public async popChildNavPageWithPageTracking(options: any = {animate: false}): Promise<any>{
        const activeChildNav = this.getActiveChildNav();
        if(activeChildNav){
             // Never pop a child nav's last page. ion-nav rejects it with "navigation stack needs
             // at least one root page" and empties the pane, which collapses the host page's
             // layout — on the home page that reads as the agenda list flashing to full width.
             // Callers pop after the active child nav has already switched back to the host's,
             // so a pop meant for a pushed page can land on a nav holding only its root.
             // canGoBack() is ion-nav's own answer and is authoritative: navPageStack is only a
             // mirror, and it drifts whenever a pop is attempted that ion-nav then refuses.
             const canGoBack: boolean = await activeChildNav.navCtrl?.canGoBack();
             if (!canGoBack) {
                 // Bring the mirror back in step with the real stack before bailing out.
                 if (activeChildNav.navPageStack.length > 1) {
                     activeChildNav.navPageStack = [activeChildNav.navPageStack[0]];
                 }
                 return Promise.resolve();
             }
             if (activeChildNav.navPageStack.length <= 1) {
                 return Promise.resolve();
             }
             const pageName = activeChildNav.navPageStack.pop();
             await activeChildNav.navCtrl.pop(options).catch(() => {});
            this.childNavPopObserver.next(pageName ? pageName.pageName : null);
            //return this.navService.popWithPageTracking(options,this._accountManagementNav);
        }else{
            return Promise.reject('Invalid child nav controller');
        }
    }

    popWithPageTrackingMulitplePages(steps:number, options: any = {animate: false}, navCtrl?: IonNav): Promise<any> {
      const activeNav = navCtrl ? navCtrl : this._defaultNav;
      if (activeNav) {
        if(activeNav.canGoBack() && this._pageStack.length > steps) {
          // this._popPreviousPageFromStack(steps);
          let removeIdx = this.getTotalPageStackLength()-steps;
          this._pageStack.splice(removeIdx, 1);
          this.popChildNavCtrlFromStack(this.getChildNavNameWithMultipleSteps(steps))
          this._currentPageStack$.next(this._pageStack);
          return activeNav.removeIndex(removeIdx, 1);
        }
      } else {
          return Promise.reject('NavigationService: popWithPageTracking: Nav controller undefined');
      }
  }

    private _popPreviousPageFromStack(steps:number) {
      let pageStackLastIdx = this.getTotalPageStackLength()-1;
      this._pageStack.splice(pageStackLastIdx-steps, 1);
      this._currentPageStack$.next(this._pageStack);
    }

    public popChildNavPageWithPageTrackingMultipleSteps(steps:number, options: any = {animate: false}): Promise<any>{
      if(this.getActiveChildNav()){
          let sliceEndIndex = this.getActiveChildNav().navPageStack.length - steps;
          if(sliceEndIndex<1) sliceEndIndex = 1
          this.getActiveChildNav().navPageStack = this.getActiveChildNav().navPageStack.slice(0,sliceEndIndex);
          return this.getActiveChildNav().navCtrl.popTo(sliceEndIndex-1, options);
      }else{
          return Promise.reject('Invalid child nav controller');
      }
    }

    public popToRootChildNavPageWithPageTracking(options: any = {animate: false}): Promise<any>{
        if(this.getActiveChildNav()){
            this.getActiveChildNav().navPageStack = [this.getActiveChildNav().navPageStack[0]];
            return this.getActiveChildNav().navCtrl.popToRoot(options);
        }else{
            return Promise.reject('Invalid child nav controller');
        }
    }

    getActiveChildNavName():ChildNavNames {
        return this._activeChildNavName;
    }

    getChildNavNameWithMultipleSteps(steps:number):ChildNavNames {
      return this._rightPaneNavCtrlStack[this._rightPaneNavCtrlStack.length-steps].navName;
  }

    getActiveChildNavViewPageName():PageName {
        return (this.getActiveChildNav() && this.getActiveChildNav().navPageStack?.length > 0) ? this.getActiveChildNav().navPageStack[this.getActiveChildNav().navPageStack.length - 1].pageName : undefined;
    }

    /**
     * Top page of a named child nav, regardless of which child nav is currently active.
     * A master page pushed over a host page registers its own child nav and only unregisters it in
     * ngOnDestroy — which Angular runs after the pop transition — so a host page that reads
     * getActiveChildNavViewPageName() while it is being revealed sees the outgoing page's nav
     * (rooted at NothingSelectedView) instead of its own, and collapses its right pane for a frame.
     */
    getChildNavViewPageNameFor(navName: ChildNavNames): PageName {
        for (let i = this._rightPaneNavCtrlStack.length - 1; i >= 0; i--) {
            const entry = this._rightPaneNavCtrlStack[i];
            if (entry.navName === navName) {
                return entry.navPageStack?.length > 0 ? entry.navPageStack[entry.navPageStack.length - 1].pageName : undefined;
            }
        }
        return undefined;
    }

    getActiveChildNavViewMasterPageName():PageName {
        return (this.getActiveChildNav() && this.getActiveChildNav().navPageStack?.length > 0) ? this.getActiveChildNav().navPageStack[this.getActiveChildNav().navPageStack.length - 1].masterPageName : undefined;
    }

    getPreviousActiveChildNavViewPageName():PageName {
      return (this.getActiveChildNav() && this.getActiveChildNav().navPageStack?.length > 1) ? this.getActiveChildNav().navPageStack[this.getActiveChildNav().navPageStack.length - 2].pageName : undefined;
    }

    getRootActiveChildNavViewPageName():PageName {
      return (this.getActiveChildNav() && this.getActiveChildNav().navPageStack?.length > 0) ? this.getActiveChildNav().navPageStack[0].pageName : undefined;
    }

    getCurrentPageName(): PageName {
        return (this._pageStack && this._pageStack.length > 0) ? this._pageStack[this._pageStack.length - 1].pageName : undefined;
    }

    getAllPageStack(): PageStack[] {
      return this._pageStack ? this._pageStack : undefined;
    }

    getPreviousPageName(): PageName {
        return (this._pageStack && this._pageStack.length > 1) ? this._pageStack[this._pageStack.length - 2].pageName : undefined;
    }

    getCurrentMasterPageName(): PageName {
        return (this._pageStack && this._pageStack.length > 0) ? this._pageStack[this._pageStack.length - 1].masterPageName : undefined;
    }

    getCurrentPageStack(): PageStack {
        return (this._pageStack && this._pageStack.length > 0) ? this._pageStack[this._pageStack.length - 1] : undefined;
    }

    getTotalPageStackLength(): number {
      return this._pageStack ? this._pageStack.length : undefined;
    }

    isInMainAppView(): boolean {
        return this._pageStack && this._pageStack.length > 0 && this._pageStack[0].pageName === PageName.GoAppActivitiesPageComponent;
    }

    private _pushToStack(pageStack: PageStack) {
        this._pageStack.push(pageStack);
        this._currentPageStack$.next(this._pageStack);
    }

    private _popFromStack() {
        this._pageStack.pop();
        this._currentPageStack$.next(this._pageStack);
    }
}
